import { BackButton } from '@/shared/components'

interface StepHeaderProps {
  title?: string
  currentStep: number
  totalSteps: number
  onBack?: () => void
  showBackButton?: boolean
  hideProgress?: boolean
}

export function StepHeader({
  title,
  currentStep,
  totalSteps,
  onBack,
  showBackButton = true,
  hideProgress = false
}: StepHeaderProps) {
  const progress = ((currentStep + 1) / totalSteps) * 100
  // Round to nearest 5%
  const roundedProgress = Math.round(progress / 5) * 5

  return (
    <div className="mb-8 mx-auto max-w-[42rem] scale-[0.92] rounded-[26px]">
      <div className="text-center">
        {title ? <h1 className="mb-4 text-4xl font-semibold text-gray-900">{title}</h1> : null}
        {!hideProgress && (
          <>
            <div className="flex flex-col items-end mb-1 px-2">
              <span className="text-xs text-gray">{roundedProgress}% Complete</span>
            </div>
            <div className="mx-auto h-2 w-full rounded-full bg-gray-200">
              <div
                className="h-2 rounded-full bg-[#E65300] transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="flex w-full justify-end px-2 mt-1">
              <span className="text-[11px] text-primary font-medium">
                Information is being saved for shorter callback times.
              </span>
            </div>
          </>
        )}

        {showBackButton && onBack ? (
          <div className="mx-auto mt-5 w-full">
            <BackButton onClick={onBack} className="w-full justify-start" />
          </div>
        ) : null}
      </div>
    </div>
  )
}
